import React, { useContext, useState, useEffect } from 'react';
import Head from 'next/head';
import Router from 'next/router';
import Link from 'next/link';
import Image from 'next/image';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import appContext from '../Context/appContext';
// import appConfig from '../appConfig';
import StorageService from '../services/storageService';
import axios from '../utils/ajax';

import emailValidationWithError from '../helpers/emailValidationWithError';
import mobileNoValidationWithError from '../helpers/mobileNoValidationWithError';
import nameValidationWithError from '../helpers/nameValidationWithError';

import FullscreenLoader from '../components/FullScreenLoader';
import GiftCardFaq from '../components/giftCard/GiftCardFaq';
import RecipientForm from '../components/giftCard/RecipientForm';
import * as WEBSITES from '../constants/website';
import { DEFAULT_ZIPCODE } from '../constants/default';
import getHost from '../helpers/gethost';
import getTransformedImageURLs from '../helpers/getTransformedImageURLs';
import pageDisable from '../helpers/pageDisableHelper';
import Page404 from './404';
import { useDispatch } from 'react-redux';
import { setCustomerInfo } from '../redux/slices/cartSlice';
import { withConfig } from '../lib/withConfig';
import { useConfigData } from '../Context/ConfigProvider';

const canonicalHref = `https://${getHost()}/gift-cards`; //same used for og:url

const GiftCard = ({ html, giftCards, error }) => {

  const [recipientDetails, setRecipientDetails] = useState({
    name: '',
    nameError: null,
    customMessage: '',
    email: '',
    emailError: null,
    phoneNumber: '',
    phoneNumberError: null,
    amount: '',
    productImage: '',
    country_code: 1,
    product_id: '',
    ageCheck: false,
    ageCheckError: null,
    isGiftCard: 1
  });
  const [loading, setLoading] = useState(false);
  // const { dispatch } = useContext(appContext);
  const dispatchRedux = useDispatch()
  // const { data: giftCards } = fetchGiftCard();
  const appConfig = useConfigData();
  // Gift Meta Data
  const giftMetaData = {
    GIFT_IMAGE:
      giftCards &&
        giftCards.products &&
        giftCards.products.length &&
        giftCards.products[0].images &&
        giftCards.products[0].images.length
        ? giftCards.products[0].images[0]
        : 'https://saas3-operator1-public-data.s3.us-west-2.amazonaws.com/grassdoor/web_static_files/og-gift.png',
    GIFT_META_TITLE: `Gift Cards for Weed Delivery | ${appConfig.APP_NAME}`,
    GIFT_META_DESCRIPTION:
      'Give the gift of fast cannabis delivery. Redeem gift cards and shop hundreds of the hottest cannabis products; get your favorites delivered to your door.'
  };

  useEffect(() => {
    if (giftCards) {
      const localGift = StorageService.getRecipientData();
      if (localGift) {
        setRecipientDetails({
          ...recipientDetails,
          ...localGift
        });
      } else {
        setRecipientDetails({
          ...recipientDetails,
          amount: giftCards.products && giftCards.products.length && giftCards.products[0].amounts[0],
          productImage: giftCards.products && giftCards.products.length && giftCards.products[0].images[0],
          product_id: giftCards.products && giftCards.products.length && giftCards.products[0].master_product_id
        });
      }
    }
  }, [giftCards]);

  function onChangeRecipient(e) {
    setRecipientDetails({ ...recipientDetails, [e.target.name]: e.target.value, [`${e.target.name}Error`]: null });
  }

  function onChangeCheckbox(e) {
    setRecipientDetails({ ...recipientDetails, [e.target.name]: e.target.checked, [`${e.target.name}Error`]: null });
  }

  function checkout() {
    const { email, phoneNumber, ageCheck, name } = recipientDetails;
    const emailError = emailValidationWithError(email);
    const phoneNumberError = mobileNoValidationWithError(phoneNumber);
    const nameError = nameValidationWithError(name, 'Full Name');
    const ageCheckError = ageCheck ? null : true;
    if (emailError !== null || phoneNumberError !== null || ageCheckError !== null || nameError !== null) {
      setRecipientDetails({ ...recipientDetails, emailError, phoneNumberError, ageCheckError, nameError });
      const element = document.getElementById('recipient-form');
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center'
        });
      }
    } else {
      setLoading(true);
      setRecipientDetails({
        ...recipientDetails,
        // country_code: userInfo.country,
        product_id: giftCards && giftCards.products && giftCards.products.length && giftCards.products[0].master_product_id
      });
      // dispatch({ type: 'setCustomerInfo', payload: { useGiftWalletAmount: true } });
      dispatchRedux(setCustomerInfo({ useGiftWalletAmount: true }))
      StorageService.setRecipientData(recipientDetails);
      Router.push({
        pathname: '/checkout',
        query: 'giftcard=true'
      });
      setLoading(false);
    }
  }

  function handleChange(name, value) {
    setRecipientDetails({ ...recipientDetails, [name]: value });
  }

  const getUrl = ({ src, width }) => {
    return `${src}?w=${width}`;
  };
  if (error) {
    return <Page404 />;
  }

  const { amount, productImage } = recipientDetails;



  return (
    <>
      <Head>
        <title>{giftMetaData.GIFT_META_TITLE}</title>
        <meta name="description" content={giftMetaData.GIFT_META_DESCRIPTION} />
        <meta property="og:title" content={giftMetaData.GIFT_META_TITLE} />
        <meta property="og:description" content={giftMetaData.GIFT_META_DESCRIPTION} />
        <meta property="og:image" content={giftMetaData.GIFT_IMAGE} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalHref} />
        <link rel="canonical" href={canonicalHref} />
      </Head>
      <div className="gift-card">

        <div className="banner mb-4">
          <div className="container">
            {/* <div className="main-logo">
              <Link prefetch={false} href="/">
                <a href="/">
                  <img src="https://static-images.grassdoor.com/grassdoor.com/web_static_files/logo-grassdoor.svg" alt={appConfig.APP_NAME} />
                </a>
              </Link>
            </div> */}
            <h2 className="fade-in-bottom">Gift Cards </h2>
            <p className="fade-in-bottom delay md-grey-color">The perfect present for all your best buds</p>
            <div className="card-images">
              <img
                src={`static/images/${process.env.NEXT_PUBLIC_APP === WEBSITES.GRASSDOOR ? 'grassdoorCard1' : 'notGrassdoorCard1'
                  }.jpg`}
                alt="Weed Delivery Gift Card Photo"
                className="fade-card1"
              />
              <img
                src={`static/images/${process.env.NEXT_PUBLIC_APP === WEBSITES.GRASSDOOR ? 'grassdoorCard2' : 'notGrassdoorCard2'
                  }.jpg`}
                alt="Weed Delivery Gift Card Photo"
                className="fade-card2"
              />
            </div>
            <p className="fade-in-bottom delay md-grey-color below-image">
              Give the gift of cannabis. Usable in all California delivery zones. Credits never expire!
            </p>
          </div>
        </div>


        <div className="container slider-selected-container">
          <div className="row">
            <div className="selected-style-wrapper col-12 col-lg-6 order-lg-2">
              <p className="preview">Preview</p>
              <div className="selected-style top-left">
                <img
                  src={
                    productImage ||
                    (giftCards && giftCards.products && giftCards.products.length && giftCards.products[0].images[0])
                  }
                  alt=""
                />
                <p className="price">
                  $ {amount || (giftCards && giftCards.products && giftCards.products.length && giftCards.products[0].amounts[0])}
                </p>
              </div>

              <GiftCardFaq className="d-none d-lg-block" />
            </div>
            <div className="sliders-wrapper col-12 col-lg-6 ">
              <div className="slider-container card-styles ">
                <p>Gift Card Style</p>
                <div className="gift-card-slider">
                  {giftCards &&
                    giftCards.products &&
                    giftCards.products.length &&
                    giftCards.products[0].images.map((item, index) => (
                      <div
                        className={`gift-card-style ${productImage == item ? 'selected' : ''}`}
                        onClick={() => handleChange('productImage', item)}
                        key={index}
                      >
                        <img src={getTransformedImageURLs(item, 'png').srcSmall} alt="" />
                      </div>
                    ))}
                </div>
              </div>
              <div className="slider-container amount  ">
                <p>Gift Card Amount</p>
                <div className="slider">
                  {giftCards &&
                    giftCards.products &&
                    giftCards.products.length &&
                    giftCards.products[0].amounts.map((item, index) => (
                      <div
                        className={`card-amount ${amount == item ? 'selected' : ''}`}
                        onClick={() => handleChange('amount', item)}
                        key={index}
                      >
                        ${item}
                      </div>
                    ))}
                </div>
              </div>

              <RecipientForm
                recipientDetails={recipientDetails}
                onChangeRecipient={onChangeRecipient}
                onChangeCheckbox={onChangeCheckbox}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <GiftCardFaq className="d-lg-none mobile" />
            </div>
          </div>
        </div>
        <div className="sticky-btn has-box-shadow-top">
          <div className="container d-flex  align-items-center px-0 px-lg-2">
            <div className="col-6 col-lg-10">
              <div className="bold title">Gift Card Amount</div>
              <div className="price">
                <span className="new-price">
                  $ {amount || (giftCards && giftCards.products && giftCards.products.length && giftCards.products[0].amounts[0])}
                </span>
              </div>
            </div>
            <div className="text-center checkout-btn-holder d-flex justify-content-between justify-content-lg-center align-items-center col-6 col-lg-2">
              {/* <div className="d-lg-none bold title">Gift Card</div> */}

              <button className="btn btn-primary checkout-btn bold btn-block has-box-shadow rouded-button" onClick={checkout}>
                Checkout
              </button>
            </div>
          </div>
        </div>
        {loading && <FullscreenLoader hasTransparentBg />}
      </div>
    </>
  );
};

export default pageDisable(GiftCard);

async function getServerSidePropsFunction({ req, res }) {
  const host = get(req, 'headers.host', '');
  const promiseArray = [];
  let cmsData = {};

  try {
    promiseArray.push(
      axios({
        url: `${process.env.NEXT_PUBLIC_SECURE_EC2_URL}/cms/gift-cards`,
        method: 'GET',
        headers: { 'x-origin': host, zc: DEFAULT_ZIPCODE, 'saas-domain': host, }
      })
    );
    const response = await Promise.all(promiseArray);
    const htmlData = response && response[0] ? get(response[0], 'data.data', {}) : {};
    cmsData = htmlData;
  } catch (error) {
    console.error(error, 'gift cards cms');
  }

  try {
    const giftCards = await axios({
      url: `${process.env.NEXT_PUBLIC_SECURE_EC2_URL}/products/gift_cards?is_referral=0`,
      method: 'GET',
      headers: { 'x-origin': host, zc: DEFAULT_ZIPCODE, 'saas-domain': host, }
    });
    const giftData = get(giftCards, 'data', {});

    return {
      props: { html: cmsData, giftCards: giftData }
    };
  } catch (error) {
    console.error('Gift Cards', error);
    return {
      props: { html: {}, giftCards: {} }
    };
  }
}
export const getServerSideProps = withConfig(getServerSidePropsFunction)